import type { Profile } from '@/interfaces/auth';

export function isAdmin(profile?: Profile | null): boolean {
  if (profile?.khai_bao_nguoi_su_dung_data?.is_administrator === true) {
    return true;
  }
  const uuid = profile?.uuid;
  return (
    (Boolean(uuid) && uuid === '72c67d87-61b2-44e3-b90b-1bdfd9d2d3a6') ||
    uuid === '4bc94007-75cb-4c51-b703-446c1bad660f' ||
    uuid === '0d5d1b0f-7511-4adc-9234-cc1a30c9932f' ||
    uuid === '9bd2b719-3f90-4ae2-97b9-1b0acaafdde6'
  );
}

export function isAdminUuid(uuid?: string | null, profile?: Profile | null): boolean {
  if (profile?.khai_bao_nguoi_su_dung_data?.is_administrator === true) {
    return true;
  }
  return (
    (Boolean(uuid) && uuid === '72c67d87-61b2-44e3-b90b-1bdfd9d2d3a6') ||
    uuid === '4bc94007-75cb-4c51-b703-446c1bad660f' ||
    uuid === '0d5d1b0f-7511-4adc-9234-cc1a30c9932f' ||
    uuid === '9bd2b719-3f90-4ae2-97b9-1b0acaafdde6'
  );
}
